import { fetchApi } from './api';

const TOKEN_KEY = 'verstrat_admin_token';

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAdmin = () => Boolean(getAdminToken());

export class AdminAuthError extends Error {}

export const adminFetch = async (endpoint, options = {}, token = getAdminToken()) => {
    try {
        return await fetchApi(endpoint, {
            ...options,
            headers: {
                ...options.headers,
                Authorization: `Bearer ${token || ''}`,
            },
        });
    } catch (error) {
        if (error.status === 401) {
            clearAdminToken();
            throw new AdminAuthError('Admin session expired or password is wrong. Please log in again.');
        }
        throw error;
    }
};
